import type { IconSvgObject } from './types';

const FlashlightIcon: IconSvgObject = [
  ["path", { d: "M16 3H8C7.44772 3 7 3.44772 7 4V6C7 7.04416 7.27249 8.07025 7.79054 8.97683L9 11V20C9 20.5523 9.44772 21 10 21H14C14.5523 21 15 20.5523 15 20V11L16.2095 8.97683C16.7275 8.07025 17 7.04416 17 6V4C17 3.44772 16.5523 3 16 3Z", stroke: "currentColor", strokeLinecap: "round", strokeLinejoin: "round", strokeWidth: "1.5", key: "0" }],
  ["path", { d: "M7 6H17", stroke: "currentColor", strokeLinecap: "round", strokeLinejoin: "round", strokeWidth: "1.5", key: "1" }],
  ["path", { d: "M12 13V15", stroke: "currentColor", strokeLinecap: "round", strokeLinejoin: "round", strokeWidth: "1.5", key: "2" }]
];

export default FlashlightIcon;
